(function() {
	'use strict';

	var telephonyNumbersLoaded = false;
	var telephonyReferenceNumber = null;
	var userPermissionLevel = 0;
	var orgWatcher;
	var userWatcher;

	try {
		angular
			.module('tradeServe.utils.telephony')
			.controller('TelephonyOutboundController', [
				'TelephonyOutboundTools',
				function(TelephonyOutboundTools) {
					return TelephonyOutboundTools;
				}
			])
			.factory('TelephonyOutboundTools', [
				'$rootScope', '$q', '$localStorage', 'DefaultToasts', 'PermissionService', 'TelephonyOutboundService',
				function($rootScope, $q, $localStorage, DefaultToasts, PermissionService, TelephonyOutboundService) {
					var vm = this;

					watchOrg($rootScope, $localStorage, TelephonyOutboundService);
					watchUser($rootScope, $localStorage, PermissionService);

					vm.getCustomerExtension = function(custId, phone) {
						if (phone.isLoading || phone.telephony_ext) {
							return;
						}

						phone.isLoading = true;

						TelephonyOutboundService.getCustomerExtension(custId, phone.id)
							.then(function(resp) {
								phone.telephony_ext = resp.data.telephony_ext;
							})
							.catch(function(err) {
								DefaultToasts.displayError(err, 'Failed to get telephony extension: ');
							})
							.finally(function() {
								delete phone.isLoading;
							});
					};

					vm.getAddressExtension = function(addr) {
						if (addr.isLoading || addr.telephony_ext || !addr.contact_phone) {
							return;
						}

						addr.isLoading = true;

						TelephonyOutboundService.getAddressExtension(addr.id)
							.then(function(resp) {
								addr.telephony_ext = resp.data.telephony_ext;
							})
							.catch(function(err) {
								DefaultToasts.displayError(err, 'Failed to get telephony extension: ');
							})
							.finally(function() {
								delete addr.isLoading;
							});
					};

					vm.showsFullNumber = function(container) {
						return !vm.showOutboundNumber(container) || userPermissionLevel > 2;
					};

					vm.getPartialNumber = function(container, number) {
						if (!number || number.length < 1) {
							return '';
						}

						if (!vm.showOutboundNumber(container)) {
							return number;
						}

						switch (userPermissionLevel) {
							case 1:
								return number.replace(/[\d]/g, 'x');
							case 2:
								return number.substr(0, number.length - 4).replace(/[\d]/g, 'x') + number.substr(-4);
							default:
								return number;
						}
					};

					vm.getOutboundNumber = function() {
						return telephonyReferenceNumber;
					};

					vm.showOutboundNumber = function(number) {
						return userPermissionLevel !== 0 && number && number.telephony_ext && telephonyReferenceNumber;
					};

					vm.isReady = function() {
						return telephonyNumbersLoaded;
					};

					return vm;
				}
			])
			.directive('telephonyOutbound', [
				function() {
					return {
						restrict: 'E',
						controller: 'TelephonyOutboundController',
						controllerAs: 'outbound',
						transclude: true,
						template: '<div ng-if="outbound.isReady()"><ng-transclude></ng-transclude></div>',
					};
				}
			]);
	} catch(err) {
		return;
	}

	function watchOrg($rootScope, $localStorage, TelephonyOutboundService) {
		if (!orgWatcher) {
			orgWatcher = $rootScope.$watch(
				function() {
					return $localStorage.selectedOrg && $localStorage.selectedOrg.id;
				},
				function() {
					telephonyReferenceNumber = null;
					telephonyNumbersLoaded = false;
					TelephonyOutboundService.getOutboundNumber()
						.then(function(resp) {
							telephonyReferenceNumber = resp.data.reference && resp.data.reference.number;
						})
						.finally(function() {
							telephonyNumbersLoaded = true;
						});
				}
			);
		}
	}

	function watchUser($rootScope, $localStorage, PermissionService) {
		if (!userWatcher) {
			userWatcher = $rootScope.$watch(
				function() {
					return $localStorage.userData && $localStorage.userData.id;
				},
				function() {
					userPermissionLevel = !PermissionService.hasPermission('web.telephony.outbound.enabled')
						? 0
						: PermissionService.hasPermission('web.telephony.outbound.full_number')
							? 3
							: PermissionService.hasPermission('web.telephony.outbound.partial_number')
								? 2
								: 1;
				}
			);
		}
	}
})();
